import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'

export const useGetAllCampaigns = () => {
  const get = useTypedApiClient({
    path: '/admin/campaigns',
    method: 'get',
  })
  const { currentStateId } = useCurrentStateStore()

  return useQuery({
    queryKey: ['/admin/campaigns'],
    queryFn: async () => {
      const { data } = await get('', {
        headers: currentStateId
          ? { 'Current-State-Id': currentStateId.toString() }
          : undefined,
      })
      return data
    },
  })
}
